<template>
  <div class="OriginMarketList" v-title data-title="批发市场">
    <div class="pt5 pl7 text-left">
      <van-button size="small" class="btn-common" plain="" type="info"
              @click="back">返回</van-button>
      <van-button size="small" class="ml7 btn-common" plain="" type="info"
              @click="editItem({})">新增批发市场</van-button>
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="finished"
      :finished-text="records.length > 10 ? '没有更多了' :''"
      @load="loadMore"
    >
      <div class="pt5 text-left">
        <div class="row align-items-baseline line pl1 font-bold">
          <div v-for="col in columns" :key="col.dataIndex" :class="col.class">{{ col.title }}</div>
        </div>
        <div class="row align-items-baseline line pl1" :title="`注册时间：${item.createTime}`"
          v-for="(item) in records"
          :key="item.memberId">
          <template v-for="col in columns">
            <div v-if="col.dataIndex === 'action'" key="action" :class="col.class">
              <van-button size="mini" class="fc-primary" @click="editItem(item)">编辑</van-button>
              <van-button size="mini" class="fc-red" @click="deleteItem(item)">删除</van-button>
            </div>
            <div v-else :key="col.dataIndex" :class="col.class">{{ item[col.dataIndex]||'' }}</div>
          </template>
        </div>
      </div>
    </van-list>

    <van-popup v-model="detailShow" :style="{'min-width': '400px',width: '40%'}">
      <div class="pt7">新增/编辑批发市场</div>
      <div class="padding5">
        <van-field
          label-width="70px"
          v-model="detail.name"
          required
          clearable
          label="名称"
          placeholder="请输入名称"
        />
        <van-field
          label-width="70px"
          v-model="detail.address"
          required
          clearable
          label="地址"
          placeholder="请输入地址"
        />
        <van-field
          label-width="70px"
          v-model="detail.contactInfo"
          required
          clearable
          label="联系方式"
          placeholder="请输入联系方式"
        />
        <van-field
          label-width="70px"
          v-model="detail.introduction"
          required
          clearable
          label="简介"
          type="textarea"
          placeholder="请输入简介"
        />
        <van-uploader
          @click.native="clickUpload(-1)"
          class="upload-cover col"
          v-model="fileList"
          :max-count="1"
          :after-read="afterRead"
          :preview-full-image="false"
          image-fit="cover"
          @delete="deleteImage(-1)"
        >
        <div class="upload-custom">点这里上传封面</div>
        </van-uploader>
      </div>
      <div class="row justify-content-around pr10 pl10 pt5 pb5">
        <van-button @click="detailShow=false" class="btn-common" plain type="info">取消</van-button>
        <van-button @click="saveOriginMarket" class="btn-common" type="info">保存</van-button>
      </div>
    </van-popup>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getOriginMarketList, getOriginMarket, deleteOriginMarket, saveOriginMarket, uploadFile, upload,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import config from '../../config';

export default Vue.extend({
  name: 'OriginMarketList',
  components: {},
  data() {
    return {
      fileDomain: config.FILE_DOMAIN,
      loading: false,
      error: false,
      finished: false,
      size: 30,
      current: 0,
      total: 1,
      pages: 1,
      hasNext: true,
      records: [],
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
          class: ['col-6', 'pr1', 'pt1', 'pb1'],
        },
        {
          title: '地址',
          dataIndex: 'address',
          class: ['col-8', 'pr1', 'pt1', 'pb1'],
        },
        {
          title: '联系方式',
          dataIndex: 'contactInfo',
          class: ['col-6', 'pr1', 'pt1', 'pb1'],
        },
        {
          title: '操作',
          dataIndex: 'action',
          class: ['col-4', 'pr1', 'pt1', 'pb1'],
        },
      ],
      detail: {

      },
      detailShow: false,
      params: {
      },
      mobileList: [
        {
          mobile: '',
          name: '',
        },
      ],

      uploadIndex: -1,
      fileList: [],
    };
  },
  methods: {
    deleteImage(index) {
      this.uploadIndex = index;
      this.$set(this.detail, 'cover', '');
      this.fileList = [];
    },
    clickUpload(index) {
      this.uploadIndex = index;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      this.uploadSource(file.file);
    },
    uploadSource(file) {
      this.loading = true;
      const params = new FormData();
      params.append('file', file);
      upload(uploadFile, params).then((url = '') => {
        this.$set(this.detail, 'cover', url);
        this.fileList = [{ url: this.fileDomain + url, tempurl: url }];
      }).catch((e) => {
        console.log(e);
      }).then(() => {
        this.loading = false;
      });
    },
    formatFileList() {
      if (this.detail.cover) {
        this.fileList = [{
          url: this.fileDomain + this.detail.cover,
        }];
        return;
      }
      this.fileList = [];
    },
    addMobile() {
      this.mobileList.push({
        mobile: '',
        name: '',
      });
    },
    removeMobile(index) {
      if (this.mobileList.length === 1) {
        this.mobileList = [{
          mobile: '',
          name: '',
        }];
        return;
      }
      this.mobileList.splice(index, 1);
    },
    editItem(item = {}) {
      this.detail = { ...item };
      this.detailShow = true;
      this.getOriginMarket(item);
    },
    saveItem() {

    },
    deleteItem(item) {
      this.actionloading = true;
      this.$dialog.confirm({
        title: '确定',
        message: '删除后无法找回，确定删除吗？',
      }).then(() => {
        sendRequest({
          ...deleteOriginMarket,
          url: `${deleteOriginMarket.url}/${item.id}`,
        }).then((res) => {
          this.getData();
          this.$dialog.alert({
            message: '操作成功',
          });
        }).catch((e) => {
          console.log(e);
          this.$dialog.alert({
            message: `${e.message}`,
          });
        }).then(() => {
          this.$nextTick(() => {
            this.actionloading = false;
          });
        });
      });
    },
    saveOriginMarket() {
      sendRequest(saveOriginMarket, {
        ...this.detail,
      }).then(() => {
        this.$dialog.alert({
          message: '操作成功',
        });
        this.detailShow = false;
        this.detail = {};
        this.getData(1);
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      });
    },
    getOriginMarket(item) {
      sendRequest({
        ...getOriginMarket,
        url: `${getOriginMarket.url}/${item.id}`,
      }).then((res) => {
        this.detail = res || {};
        this.formatFileList();
      }).catch((e) => {
        console.log(e);
        this.fileList = [];
      });
    },
    loadMore() {
      if (this.pages <= this.current) {
        return;
      }
      this.getData(this.current + 1);
    },
    getData(page = 1) {
      // console.log(this.loading);
      this.error = false;
      sendRequest(getOriginMarketList, {
        current: page,
        size: this.size,
        ...this.params,
      }).then((res) => {
        const {
          total = 1, records = [], pages = 1, hasNext = false,
        } = res;
        // eslint-disable-next-line eqeqeq
        if (page == 1) {
          this.records = records || [];
        } else {
          this.records = this.records.concat(records || []);
        }
        this.total = total;
        this.pages = pages;
        this.hasNext = hasNext;
        this.current = page;
        if (!this.hasNext || (records || []).length < this.size || this.records.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
        this.error = true;
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    goDetail(e = {}) {
      storage.local.set('busername', e.username || '');
      if (e.id) {
        this.$router.push(`/user/edit/${e.type === 3 ? 'hzdw' : 'bjs'}/${e.id || ''}`);
      } else {
        this.$router.push('/user/home');
      }
    },
    goNotice(e = {}) {
      this.$router.push('/notice/info');
    },
    goData(url) {
      this.$router.push(url || '/data/info');
    },
    goSet(e = {}) {
      // storage.local.set('busername', e.username || '');
      this.$router.push(`/user/sync/rule/${e.id || ''}`);
    },
    back() {
      // this.$router.back();
      this.$router.push('/home');
    },
  },
  created() {
  },
});
</script>
<style scoped>
  .OriginMarketList {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 14px;
  }
  input, select {
    height: 26px;
    width: 105px;
    font-size: 14px;
    border: 1px solid #a7a9af;
    background-color: #ffffff;
    border-radius: 4px;
  }
  .keywords-input {
    width: 180px;
  }
  .date-select {
    width: 90px;
  }
  .button {
    min-width: 80px;
    height: 26px;
  }
  .upload-custom {
    width :100%;
    border: 1px solid #a7a9af;
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .upload-cover {
    width: 100%;
    margin-top: 16px;
    /* border: 1px solid #a7a9af!important; */
  }
  .upload-cover >>> .van-uploader__input-wrapper {
    flex:1;
  }
  .upload-cover >>> .van-uploader__preview {
    margin: 0;
  }
  .upload-cover >>> .van-image,.van-uploader__upload {
    width: 100%;
    height: auto;
    min-height: 70px
  }
</style>
